import { cx } from '@/Ship/Helpers/cssClass'

import styles from './TabLabel.module.css'

import type { ReactNode } from 'react'

interface TabLabelProps {
    children: ReactNode
    /** Кількість записів у вкладці; без лічильника, коли undefined або 0 */
    count?: number | undefined
}

/**
 * Підпис вкладки з лічильником-пігулкою замість «Назва (3)». Колір пігулки задає
 * контекст (у картці: нейтральна, на активній вкладці — акцентна, див. AppDrawer).
 * Нуль не показується: акцентна «0» на активній вкладці читається як тривога.
 */
export const TabLabel = ({ children, count }: TabLabelProps) => (
    <span className={cx(styles, 'label')}>
        {children}
        {count !== undefined && count > 0 && (
            <span className={`${cx(styles, 'count')} wl-tab-count`}>{count > 99 ? '99+' : count}</span>
        )}
    </span>
)
